"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RtlDocumentLoadInstrumentation = void 0;
const instrumentation_1 = require("@opentelemetry/instrumentation");
const api_1 = require("@opentelemetry/api");
const shared_1 = require("../shared");
const INSTRUMENTATION_NAME = 'rtl-document-load';
class RtlDocumentLoadInstrumentation extends instrumentation_1.InstrumentationBase {
    constructor(version) {
        super(INSTRUMENTATION_NAME, version, { enabled: true });
    }
    init() { }
    enable() {
        window.addEventListener('load', this.loadEvent);
    }
    disable() {
        window.removeEventListener('load', this.loadEvent);
    }
    loadEvent(event) {
        const tracer = api_1.trace.getTracer(INSTRUMENTATION_NAME);
        tracer.startActiveSpan('documentLoad', (documentLoadSpan) => {
            const paintsEntries = window.performance.getEntriesByType('paint');
            if (paintsEntries) {
                for (let i = 0; i < paintsEntries.length; i++) {
                    const paintEntry = paintsEntries[i];
                    const span = tracer.startSpan(paintEntry.name);
                    (0, shared_1.endSpanWithDurationFromMilliseconds)(span, paintEntry.startTime);
                }
                const navigationEntries = window.performance.getEntriesByType('navigation');
                if (navigationEntries && navigationEntries.length > 0) {
                    const navigationEntry = navigationEntries[0];
                    if (navigationEntry.domInteractive) {
                        const span = tracer.startSpan('domInteractive');
                        (0, shared_1.endSpanWithDurationFromMilliseconds)(span, navigationEntry.domInteractive);
                    }
                }
            }
            (0, shared_1.endSpanWithDurationFromMilliseconds)(documentLoadSpan, event.timeStamp);
        });
    }
}
exports.RtlDocumentLoadInstrumentation = RtlDocumentLoadInstrumentation;
